// used to lazyload div's which hold javascript sources
// example use: <div data-js="https://library/to/load.js" class="lazyload"></div>

const lazyBeforeUnveil = () => {
    document.addEventListener('lazybeforeunveil', (e) => {
        const ajax = $(e.target).data('js');

        if (ajax) {
            const resource = document.createElement('script');
            resource.async = 'true';
            resource.src = ajax;

            const script = document.getElementsByTagName('script')[0];
            script.parentNode.insertBefore(resource, script);
        }
    });
};

// Module startup
const init = () => {
    lazyBeforeUnveil();
};

export { init };
